import { CLEAR, SET_MEDIA } from '../actions/Playback';
;
const initialState = {
    onStarted: [],
    onResumed: [],
    onScrubbed: [],
    onPaused: [],
    onFinished: [],
    onStopped: [],
    onRebuffered: [],
    onError: [],
    bufferTime: 0,
    currentTime: 0,
    playbackStarted: false,
};
const reducer = {
    [CLEAR]: (state, action) => initialState,
    [SET_MEDIA]: (state, action) => {
        return Object.assign(Object.assign({}, state), action.payload.events);
    },
};
export function PlaybackEventsReducer(state = initialState, action) {
    if (reducer[action.type]) {
        return reducer[action.type](state, action);
    }
    else {
        return state;
    }
}
